import DataService from '../../core/services/data.service';
import { UiStringModel } from '../../core/models/ui-string.model';
import moment from 'moment';
import 'slick-carousel';

class EventTileCarouselViewModel {
    private dataService: DataService;
    private uiStrings: UiStringModel;

    public accountId: KnockoutObservable<number>;

    private isMatomoTrackingEnabled = ko.observable(false);
    private accountName = ko.observable('');

    constructor(private params: any) {
        this.accountId = params.accountId;
        this.dataService = params.dataService as DataService;
        this.uiStrings = params.uiStrings as UiStringModel;

        const useSubscriber = params.useSubscriber as boolean;

        this.isMatomoTrackingEnabled((window as any).global.config.isMatomoTrackingEnabled);

        if (!useSubscriber) {
            this.getEventOrganiserEvents(this.accountId());
            this.getEventOrganiserAccountName(this.accountId());

            return;
        }

        const carouselSubscriber = this.accountId.subscribe((data) => {
            if (data && data > 0) {
                carouselSubscriber.dispose();
                this.getEventOrganiserEvents(data);
                this.getEventOrganiserAccountName(data);
            }
        });
    }

    private getEventOrganiserAccountName(accountId: number) {
        this.dataService.GetAccountName(accountId)
            .done((data: any) => {
                this.accountName(data.accountName);
            })
            .fail(() => {
                this.accountName('');
            });
    }

    private getEventOrganiserEvents(accountId: number) {
        this.dataService.GetEventOrganiserEvents(accountId)
            .done((result: any) => {
                if (result.results.length > 0) {
                    this.displayCarouselHeader(true);

                    $.each(result.results, (e, obj) => {
                        this.createEventTile(obj);
                    });

                    this.initCarousel();
                } else {
                    this.displayCarouselHeader(false);
                }
            });
    }

    private initCarousel() {
        var carousel = $('.event-tile-carousel');

        carousel.on('init', function (event, slick) {
            var numSlides = slick.$slides.length;
            for (var i = 0; i < numSlides; i++) {
                slick.$slides[i].classList.remove('active');
                if (i >= 0 && i < slick.options.slidesToShow) {
                    slick.$slides[i].classList.add('active');
                }
            };
        });

        carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            if (slick.activeBreakpoint == null) nextSlide = nextSlide - 1;
            if (slick.activeBreakpoint == 600) nextSlide = nextSlide + 1;

            let blurredSlides = slick.activeBreakpoint == 600 ? 1 : 0;
            let firstSlideIndex = 0;
            let lastSlideIndex = slick.$slides.length - 1;

            for (var i = 0; i < slick.$slides.length; i++) {
                slick.$slides[i].classList.remove('active');
                if (i >= nextSlide - blurredSlides && i < (nextSlide - blurredSlides + slick.options.slidesToShow)) {
                    slick.$slides[i].classList.add('active');
                }
            }

            if (currentSlide === firstSlideIndex || currentSlide - 1 === firstSlideIndex || nextSlide === firstSlideIndex) {
                slick.$slides[2].classList.add('active');
            }

            if (currentSlide + 1 === lastSlideIndex) {
                slick.$slides[currentSlide - 1].classList.add('active');
            }
        });

        // Work around for infinitely scrolling through slides; forces to show 3 active slides when scrolling through last and first 3 slides
        carousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            let firstSlideIndex = 0;
            let lastSlideIndex = slick.$slides.length - 1;

            if (currentSlide === lastSlideIndex) {
                slick.$slides[currentSlide - 2].classList.add('active');
            }

            if (currentSlide === firstSlideIndex || currentSlide - 1 === firstSlideIndex || nextSlide === firstSlideIndex) {
                slick.$slides[2].classList.add('active');
            }
        });

        carousel.slick({
            dots: false,
            variableWidth: true,
            slidesToScroll: 3,
            slidesToShow: 3,
            centerMode: true,
            focusOnSelect: true,
            infinite: false,
            initialSlide: 1,
            arrows: true,
            adaptiveHeight: false,
            prevArrow: '<div class="d-flex flex-column justify-content-center slick-arrow--left"><div><img src="/media/imgs/cd27acc216e2f30229fb1fe71a7cca5370bcea80.svg" alt="nav-left"></div></div>',
            nextArrow: '<div class="d-flex flex-column justify-content-center slick-arrow--right"><div><img src="/media/imgs/cd27acc216e2f30229fb1fe71a7cca5370bcea80.svg" alt="nav-right"></div></div>',
            responsive: [
                {
                    breakpoint: 1224,
                    settings: {
                        slidesToShow: 3,
                        initialSlide: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        initialSlide: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        initialSlide: 0,
                    }
                }
            ]
        });
    }

    private createEventTile(event: any) {
        let eventThumbnail = '';
        const eventSitePath = this.uiStrings.eventSitePath;
        const brand = this.uiStrings.brand.toLowerCase();

        if (event.thumbnailImage || !event.heroImage) {
            if (event.thumbnailImage) {
                eventThumbnail = event.thumbnailImage;
            } else if (!event.thumbnailImage) {
                eventThumbnail = brand === 'vancoevents'
                    ? '/media/imgs/53d1c04127dd62b25d2f3f69280947f1829a29b9.png'
                    : '/media/imgs/f8ad110cc462929c743c4bb899fc391ee4d2aceb.png';
            }
        } else if (!event.thumbnailImage && event.heroImage) {
            eventThumbnail = event.heroImage;
        }

        let sessionTime = this.getSessionDates(event);

        $('#dv-event-tiles').append(`
            <div id="sr_${event.id}" class="event-tile" data-event-id="${event.id}" data-event-name="${event.eventDisplayName}">
                <a href="${eventSitePath}/landing/${event.id}">
                    <img src="${eventThumbnail}" alt="Hero Image" loading="lazy" />
                    <div class="p-4 event-tile-body d-flex flex-column justify-content-between">
                        <h6>${event.eventDisplayName}</h6>
                        <div class="event-tile-body-info">
                            <span><img class="icon" src="/media/imgs/8e5bee9b80d8a5b23726e623ab7e6b46708063dd.svg" alt="date">${sessionTime}</span>
                            <span><img class="icon" src="/media/imgs/d627b8891a536bf087440b7f088df27d80814155.svg" alt="venue">${event.venueName}</span>
                        </div>
                    </div>
                </a>
            </div>
        `);

        if (this.isMatomoTrackingEnabled) {
            this.contructDataLayer(event, eventSitePath);
        }
    }

    private getSessionDates(event: any) {
        let dateFormat = 'dddd D MMMM YYYY';
        let dateOnlyFormat = 'D MMMM YYYY';
        let firstSessionTime = moment(event.eventStartDate).format(dateFormat);
        let lastSessionTime = moment(event.eventEndDate).format(dateFormat);
        let firstEventDate = moment(event.eventStartDate).format(dateOnlyFormat);
        let lastEventDate = moment(event.eventEndDate).format(dateOnlyFormat);

        if (typeof event.alternateLabel !== "undefined"
            && event.alternateLabel !== null
            && event.alternateLabel !== '') {
            return event.alternateLabel;
        }

        if (firstEventDate === lastEventDate) {
            return lastSessionTime;
        } else {
            return `Between ${firstSessionTime} and ${lastSessionTime}`;
        }
    }

    private contructDataLayer(event: any, eventSitePath: string) {
        $(`#sr_${event.id}`).one('click', function (e) {
            e.preventDefault();

            var eventId = $(this).attr('data-event-id');
            var eventName = $(this).attr('data-event-name');
            var eventLandingUrl = `${eventSitePath}/landing/${event.id}`;

            const _paq = (window as any)._paq = (window as any)._paq || [];
            _paq.push(['trackEvent', 'eo-event-tile-carousel', 'clicked', `${eventId}-${eventName}`, 1]);

            setTimeout(() => {
                window.location.href = eventLandingUrl;
            }, 500);
        });
    }

    private displayCarouselHeader(shouldDisplay: boolean) {
        if (shouldDisplay) {
            $('#carousel-header').show();
            $('#carousel-message').hide();
        } else {
            $('#carousel-header').hide();
            $('#carousel-message').show();
        }
    }
}

export default class EventTileCarousel {
    constructor() {
        ko.components.register('event-tile-carousel', {
            viewModel: (params: any) => new EventTileCarouselViewModel(params),
            template: `
                <div class="d-lg-flex justify-content-center">
                    <h1 id="carousel-header" style="display: none;">
                        Events by <span data-bind="text: accountName"></span>
                    </h1>
                    <span id="carousel-message" style="display: none;">
                        No current events scheduled by <span data-bind="text: accountName"></span>
                    </span>
                </div>
                <div id="dv-event-tiles" class="justify-content-center d-lg-flex event-tile-carousel">
                </div>
            `
        })
    }
}